import React, { useEffect, useRef, useState } from 'react';
import './assets/style/App.css';
import './assets/style/Colors.css';
import Layout from './pages/layout/Layout';
import { Bounce, ToastContainer } from 'react-toastify';
import {
  checkAuthenticated,
  getLoggedUserDetails,
  loginSelector,
} from './features/loginSlice';
import {
  updateDeviceStatus,
  updateSideMenuStatus,
} from './features/dashboardSlice';
import { SIDE_MENU_STATUS, STORAGE_KEY } from './utils/Constant';
import { useAppDispatch, useAppSelector } from './store/redux-hooks';
import { MapOptionType, LoggedUserType, UserType } from './utils/Types';
import {
  getZonesAndStates,
  locationFilterSelector,
} from './features/locationFilterSlice';
import {
  prepareDataToFindCity,
  prepareDataToFindZoneAndState,
  saveInLocalStorage,
} from './utils/Util';
import { getAllRoles, getRollDrops } from './features/trackLocationSlice';
import { URL } from '../src/utils/Config';
import { keyCloarkAccessData } from '././features/loginSlice';

function App() {
  const dispatch = useAppDispatch();
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const statesData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;
  const [width, setWidth] = useState<number>(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    const isMobile = width <= 768;
    if (width <= 1000) {
      dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.CLOSE));
    } else {
      dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.OPEN));
    }
    dispatch(updateDeviceStatus({ isMobile }));
  }, [width]);
  useEffect(() => {
    dispatch(checkAuthenticated());
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  useEffect(() => {
    if (user?.candidateId) {
      dispatch(getLoggedUserDetails(user.candidateId));
      dispatch(getRollDrops());
      dispatch(getAllRoles());
    }
  }, [user]);

  const handleJwtExpired = () => {
    const params = new URLSearchParams();
    params.append('client_id', URL.KEY_CLOARK_CLIENTID);
    params.append('client_secret', URL.KEY_CLOARK_CLIENTSECRET);
    params.append('grant_type', URL.KEY_CLOARK_GRANTTYPE);
    params.append('scope', URL.KEY_CLOARK_SCOPE);

    return dispatch(keyCloarkAccessData(params))
      .unwrap()
      .then((fulfilled: any) => {
        if (fulfilled?.access_token) {
          saveInLocalStorage(STORAGE_KEY.KEYCLOARK, fulfilled.access_token);
          return fulfilled.access_token;
        } else {
          throw new Error('Access token missing in response');
        }
      })
      .catch((error) => {
        console.error('Token refresh failed:', error);
        throw error; // propagate error to caller
      });
  };

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (hasFetchedRef.current) return;

    const data = prepareDataToFindZoneAndState(user, userDetails);
    if (data) {
      hasFetchedRef.current = true;

      const modifiedData = {
        zoneId: data.zoneId.length > 0 ? data.zoneId.join(',') : '',
        stateId: data.stateId.length > 0 ? data.stateId.join(',') : '',
      };

      dispatch(getZonesAndStates(modifiedData))
        .then((response: any) => {
          console.log('response-1099', response);
          if (
            response?.payload?.status === 'FAILED' &&
            response?.payload?.errors?.some(
              (err: { code: string; message: string | string[] }) =>
                err.code === '401' && err.message.includes('Jwt expired')
            )
          ) {
            handleJwtExpired()
              .then(() => {
                dispatch(getZonesAndStates(modifiedData)); // Retry after token refresh
              })
              .catch((e) => {
                console.error('Token refresh failed:', e);
                // Optional: redirect to login or show error
              });
          }
        })
        .catch((error) => {
          console.error('API call failed:', error);
        });
    }
  }, [userDetails, statesData]);

  useEffect(() => {
    const data = prepareDataToFindCity(
      user,
      userDetails,
      statesData,
      districtData
    );
    if (data) {
      const modifiedData = {
        zoneId: data.zoneId.length > 0 ? data.zoneId.join(',') : '',
        stateId: data.stateId.length > 0 ? data.stateId.join(',') : '',
      };
      dispatch(getZonesAndStates(modifiedData))
        .then((response: any) => {
          console.log('response-142', response);
          if (
            response?.payload?.status === 'FAILED' &&
            response?.payload?.errors?.some(
              (err: any) =>
                err.code === '401' && err.message.includes('Jwt expired')
            )
          ) {
            // Token expired, refresh and retry
            handleJwtExpired()
              .then(() => {
                dispatch(getZonesAndStates(modifiedData)); // Retry after token refresh
              })
              .catch((e) => {
                console.error('Token refresh failed:', e);
                // Optional: redirect to login or show error
              });
          }
        })
        .catch((error) => {
          console.error('getZonesAndStates failed:', error);
        });
    }
  }, [statesData]);
  return (
    <div className="App">
      <Layout />
      <ToastContainer
        className="toast-style"
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
}

export default App;
